export default function injectStaticAdContent(divContainer, adContent) {
    const div = document.createElement('div');
    div.innerHTML = adContent;
    div.children[0].style.display = 'inline-block';
    divContainer.appendChild(div);
    return div;
}
